import loginStore from './modules/login_store';
import commonStore from './modules/common_store';
import homeStore from './modules/home_store';
import addCompanyStore from "./modules/choose_compane/addCompany_store";
import userAccountStore from './modules/user_manage/user_account_store';
import userGroupStore from './modules/user_manage/user_group_store';
import userPermissionStore from './modules/user_manage/user_permission_store';
import aPoolStore from './modules/number_pool_manage/a_pool/a_pool_store';
import aNumberManageStore from './modules/number_pool_manage/a_pool/a_number_manage_store';
import xPoolStore from './modules/number_pool_manage/x_pool/x_pool_store';
import xNumberManageStore from './modules/number_pool_manage/x_pool/x_number_manage_store';
import myApplicationStore from './modules/number_pool_manage/x_pool/my_application_store';
import videoListStore from './modules/video_mamage/video_list_store';
import templateManageStore from './modules/call_card/template_store'
import signatureManageStore from './modules/call_card/signature_store'
import cardBillStore from './modules/call_card/card_bill_store'
import uploadImgStore from './modules/call_card/uploadImg_store'
import uploadRealNameImgStore from './modules/choose_compane/uploadRealNameImg_store'
import callManageStore from './modules/call_out/call_manage_store'
import taskManageStore from './modules/call_out/call_task_store';
import callLanguageStore from './modules/call_out/call_language_store'
import recordingManageStore from './modules/recording_mamage/recording_manage_store'
import languageManageStore from './modules/script_manage/language_manage_store'


export const LoginStore = new loginStore();
export const CommonStore = new commonStore();
export const HomeStore = new homeStore(CommonStore);
export const AddCompanyStore = new addCompanyStore(LoginStore,CommonStore);
export const UserAccountStore = new userAccountStore(CommonStore);
export const UserGroupStore = new userGroupStore(CommonStore);
export const UserPermissionStore = new userPermissionStore(CommonStore);
export const APoolStore = new aPoolStore(CommonStore);
export const XPoolStore = new xPoolStore(CommonStore);
export const XNumberManageStore = new xNumberManageStore(CommonStore);
export const ANumberManageStore = new aNumberManageStore(CommonStore);
export const MyApplicationStore = new myApplicationStore(CommonStore);
export const VideoListStore = new videoListStore(CommonStore);
export const TemplateManageStore = new templateManageStore(CommonStore);
export const SignatureManageStore = new signatureManageStore(CommonStore);
export const CardBillStore = new cardBillStore(CommonStore);
export const CallManageStore = new callManageStore(CommonStore);
export const TaskManageStore = new taskManageStore(CommonStore);
export const CallLanguageStore = new callLanguageStore(CommonStore);
export const templateParamUploadImgStore = new uploadImgStore(TemplateManageStore, "templateParamFileName","templateParamFileNameUrl");
export const socialCreditCertificateObjectNamesUploadImgStore = new uploadImgStore(TemplateManageStore, "socialCreditCertificateObjectNames","socialCreditCertificateObjectNamesUrl");
export const orderVoucherObjectNamesUploadImgStore = new uploadImgStore(TemplateManageStore, "orderVoucherObjectNames","orderVoucherObjectNamesUrl");
export const signAuthzCertificateObjectNamesUploadImgStore = new uploadImgStore(TemplateManageStore, "signAuthzCertificateObjectNames","signAuthzCertificateObjectNamesUrl");
export const CardFrontStore = new uploadRealNameImgStore(AddCompanyStore, "legalPersonIdFront");
export const CardBackStore = new uploadRealNameImgStore(AddCompanyStore, "legalPersonIdBack");
export const BusinessLicenseImgStore = new uploadRealNameImgStore(AddCompanyStore, "businessLicenseImage");
export const OpeningPermitImgStore = new uploadRealNameImgStore(AddCompanyStore, "bankPermitImage");
export const OperatorCardFrontStore = new uploadRealNameImgStore(AddCompanyStore, "agentIdFront");
export const OperatorCardBackStore = new uploadRealNameImgStore(AddCompanyStore, "agentIdBack");
export const RecordingManageStore = new recordingManageStore(CommonStore);
export const LanguageManageStore = new languageManageStore(CommonStore);


const store = {
    ...HomeStore,
    ...LoginStore,
    ...CommonStore,
    ...AddCompanyStore,
    ...UserAccountStore,
    ...UserGroupStore,
    ...UserPermissionStore,
    ...APoolStore,
    ...ANumberManageStore,
    ...XPoolStore,
    ...XNumberManageStore,
    ...MyApplicationStore,
    ...templateParamUploadImgStore,
    ...socialCreditCertificateObjectNamesUploadImgStore,
    ...orderVoucherObjectNamesUploadImgStore,
    ...signAuthzCertificateObjectNamesUploadImgStore,
    ...CardFrontStore,
    ...CardBackStore,
    ...BusinessLicenseImgStore,
    ...OpeningPermitImgStore,
    ...OperatorCardFrontStore,
    ...OperatorCardBackStore,
    ...RecordingManageStore,
    ...LanguageManageStore
};
export default store;
